import './style.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import { router } from './routes';
import { config } from './config';

const app = createApp(App);

const release =
  document.querySelector('meta[name="release"]')?.getAttribute('content') || undefined;

Sentry.init({
  app,
  enabled: config.sentryEnabled,
  environment: config.env,
  dsn: config.sentryDsn,
  release,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: config.env === 'local' ? 0 : 0.25,
});

app.use(router).use(createPinia()).mount('#app');
